import {
  MarketplacePaymentState,
  SalesGroupDetails,
} from 'src/WebApiController';

import { getOutstandingAmt } from './getOutstandingAmt';

/**
 * Derives the group-level payment status from a SalesGroupDetails payload.
 *
 * POS-8632: status is derived purely from amounts (owed vs received), never
 * from individual line states — a single aggregated line reading "Paid" must not
 * override an outstanding balance.
 * POS-8726: when all lines are Reversed (full refund), show Reversed instead of Unpaid.
 *
 * Returns null when payment is genuinely unknown (no totals at all).
 */
export function getGroupPaymentStatus(
  group: SalesGroupDetails
): MarketplacePaymentState | null {
  const paymentLines = group.aggregatedPaymentLines ?? [];
  const received = group.totalPaymentReceived?.amt ?? 0;
  const subtotalAmt = group.subtotal?.amt ?? 0;

  const hasReversedLines = paymentLines.some(
    (line) =>
      line.state === MarketplacePaymentState.Reversed ||
      line.state === MarketplacePaymentState.PendingReversal
  );

  const outstandingAmt = getOutstandingAmt(group);

  return received <= 0
    ? hasReversedLines
      ? MarketplacePaymentState.Reversed
      : received === 0 &&
          subtotalAmt <= 0 &&
          group.totalPaymentReceived == null &&
          group.balanceDue == null
        ? null
        : MarketplacePaymentState.Unpaid
    : outstandingAmt <= 0
      ? MarketplacePaymentState.Paid
      : MarketplacePaymentState.PartiallyPaid;
}
